import {Routes, toAbsoluteUrl} from "@buildwithflux/core";
import {History, LocationState} from "history";

export function signUp(history?: History<LocationState>, utmCampaign?: string, target?: string) {
    if (history) {
        history.push(signUpUrl());
    } else {
        window.open(signUpUrl(), target || "_self");
    }
}

export function isAuthPage(path: string): boolean {
    const authRoutes = [
        Routes.SIGN_UP,
        Routes.LOG_IN,
        Routes.LOG_OUT,
        Routes.RESET_PASSWORD,
        Routes.RESET_PASSWORD_CALLBACK,
        Routes.VERIFY_EMAIL,
        Routes.SIGN_IN,
        Routes.SIGN_OUT,
    ];
    return authRoutes.some((route) => path.startsWith(route));
}

export function signUpUrl(destinationPath?: string) {
    const path = destinationPath ?? window.location.pathname;

    if (path && path !== "undefined" && path !== "null" && !isAuthPage(path)) {
        return Routes.SIGN_UP + `?destinationPath=${encodeURIComponent(path)}`;
    }

    return Routes.SIGN_UP;
}

export function signInUrl(destinationPath?: string) {
    const path = destinationPath ?? window.location.pathname;

    if (path && path !== "undefined" && path !== "null" && !isAuthPage(path)) {
        return Routes.LOG_IN + `?destinationPath=${encodeURIComponent(path)}`;
    }

    return Routes.LOG_IN;
}

export function absoluteSignUpUrl() {
    return toAbsoluteUrl(Routes.SIGN_UP);
}

export function absoluteSignInUrl() {
    return toAbsoluteUrl(Routes.LOG_IN);
}
